import { datadogRum } from '@datadog/browser-rum'
import React from 'react';
import ReactDOM from 'react-dom';
// import {AppContainer} from 'react-hot-loader';
import 'es6-symbol/implement';
import 'es6-promise/auto';
// Styles
import '@availity/block-ui/dist/index.css';
import 'availity-uikit/scss/_bootstrap.scss';
import '@availity/date/styles.scss';
import './index.scss';

import {I18nextProvider} from 'react-i18next';
import i18next from 'i18next';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import * as serviceWorker from './serviceworker';
import './Common/interceptor/interceptor-api';
import App from './App';
import commonEn from './translations/en/common.json';
import commonEs from './translations/es/common.json';

datadogRum.init({
  applicationId: '2b3f60c9-fdd8-48a4-aa99-eb7649afc82c',
  clientToken: 'pubea1698c91e8e9b67966f7637368c1a42',
  site: 'datadoghq.com',
  service: 'supportivehousingassessment-ui',
  //  env: 'production',
  version: '1.0.0',
  sampleRate: 100,
  sessionReplaySampleRate: 100, // if not included, the default is 100
  trackResources: true,
  trackLongTasks: true,
  trackInteractions: true,
  defaultPrivacyLevel: 'mask',
  allowedTracingOrigins: ["https://perf.aws-providerexperience.anthem.com/SupportiveHousingAssessment/EN/","/https:\/\/.*\.perf.aws-providerexperience.anthem/SupportiveHousingAssessment/EN/\.com/"]
})

i18next.init({
  interpolation: { escapeValue: false },
  lng: 'en',
  resources: {
    en: {
      common: commonEn
    },
    es: {
      common: commonEs
    },
  },
})

require('isomorphic-fetch');


ReactDOM.render(
  <I18nextProvider i18n={i18next}>
    <App />
  </I18nextProvider>,
  document.getElementById('root')
);

serviceWorker.unregister();
